/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Status_UnpaidInputs */

const en_plan_status_unpaid = /** @type {(inputs: Plan_Status_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpaid`)
};

const es_plan_status_unpaid = /** @type {(inputs: Plan_Status_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin pagar`)
};

/**
* | output |
* | --- |
* | "Unpaid" |
*
* @param {Plan_Status_UnpaidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_status_unpaid = /** @type {((inputs?: Plan_Status_UnpaidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Status_UnpaidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_status_unpaid(inputs)
	return en_plan_status_unpaid(inputs)
});